import { Link } from 'react-router';
import { Team } from '@repo/types';
import { ClubNameType } from '../../../fixtures/contracts';
import { Image, ImageVariant } from '../../../common/components/Image';

export type TeamCardProps = {
  team: Team;
  nameType?: ClubNameType;
  style?: React.CSSProperties;
};

function TeamCard({
  team: { slug, fullName, shortName, nickName, threeLetterName, logo },
  nameType = ClubNameType.FullName,
  style,
}: TeamCardProps): JSX.Element {
  const getTeamName = () => {
    switch (nameType) {
      case ClubNameType.ThreeLetterName:
        return threeLetterName ?? 'N/A';
      case ClubNameType.ShortName:
        return shortName ?? 'N/A';
      case ClubNameType.FullName:
        return fullName ?? 'N/A';
      case ClubNameType.NickName:
        return nickName ?? 'N/A';
      default:
        return shortName ?? 'N/A';
    }
  };
  const teamName = getTeamName();

  return (
    <div className="team-card" style={style}>
      <Link className="team-card__link" to={`/teams/${slug}`}>
        <Image
          className="team-card__logo"
          alt={teamName}
          src={logo || 'default-team-badge.webp'}
          width="150"
          height="150"
          variant={ImageVariant.SquareLogoLarge}
        />
        <h4 className="team-card__name">{teamName}</h4>
      </Link>
    </div>
  );
}

export default TeamCard;
